import React from "react";
import {
  ClockCircleOutlined,
  SolutionOutlined,
  RiseOutlined,
  DatabaseOutlined,
} from "@ant-design/icons";
import WeekmateSvglogo from "../../assets/images/Weekmatelogo";
import HRMSImage from "../../assets/images/hrms-product.svg";
import DashboardImage from "../../assets/images/login-dashboard.png";

// Brand blue - same as the Sign In button, used for logo + feature cards.
const BRAND_BLUE = "#0077bd";

// Product-focused feature list - HRMS capabilities (not other products).
const FEATURES = [
  {
    icon: <ClockCircleOutlined />,
    title: "Attendance & Leave Automation",
    text: "Track WFH, comp-off, and shifts in one system",
  },
  {
    icon: <SolutionOutlined />,
    title: "Automated Onboarding",
    text: "Document collection and joining workflows, hands-free",
  },
  {
    icon: <RiseOutlined />,
    title: "Performance Management",
    text: "Track KRAs, KPIs, and goals with 360° surveys",
  },
  {
    icon: <DatabaseOutlined />,
    title: "Centralized Access",
    text: "All employee data, policies, and HR docs, always secure",
  },
];

const AuthBrandingSection = () => {
  return (
    <div className="branding-content">
      <div className="logo-container">
        <WeekmateSvglogo />
      </div>

      <div className="auth-features-wrapper">
        <div className="auth-text-content">
          {/* Lead with the HRMS product badge */}
          <div className="auth-product-badge">
            <div className="product-logo" style={{ background: BRAND_BLUE }}>
              <img src={HRMSImage} alt="HRMS" />
            </div>
            <span className="product-name">HRMS</span>
          </div>

          <h1 className="auth-title">
            Automate HR,<br />
            <span className="text-primary">Empower</span> people
          </h1>
          <p className="auth-subtitle">
            From onboarding to payroll and compliance, run your
            entire workforce from one place.
          </p>

          <div className="auth-feature-list">
            {FEATURES.map((feature) => (
              <div className="feature-item" key={feature.title}>
                <div
                  className="feature-logo"
                  style={{ background: BRAND_BLUE }}
                >
                  {feature.icon}
                </div>
                <div className="feature-text">
                  <h4>{feature.title}</h4>
                  <p>{feature.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="auth-dashboard-image">
          <img src={DashboardImage} alt="HRMS Dashboard Preview" />
        </div>
      </div>
    </div>
  );
};

export default AuthBrandingSection;
